import React from 'react';
import { Chip, Typography } from '@mui/material';
import ModernwashListScreen from './modernwash/ModernwashListScreen';
import PaymentStatusBadge from '../../components/PaymentStatusBadge';
import { fetchModernwashCourses } from '../../api/modernwash';
import { colors } from '../../design-system/tokens';
import { pick, formatWon } from './modernwash/format';

/**
 * 세차 프로그램 — ModernWash 키오스크 코스 구성 (read-only).
 * 계약: backend dto CourseDto = { courseId, name, tag, basePrice, active }.
 */
const isActive = (row) => {
  const raw = pick(row, ['active', 'enabled', 'isActive']);
  if (raw === undefined) return true; // 원천이 상태를 안 주면 노출 코스로 간주
  if (typeof raw === 'string') return !['false', 'off', 'disabled', 'n', '0'].includes(raw.toLowerCase());
  return Boolean(raw);
};

const COLUMNS = [
  {
    key: 'name',
    label: '코스명',
    render: (row) => (
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        {pick(row, ['name', 'courseName', 'title', 'label'], '-')}
      </Typography>
    ),
  },
  {
    key: 'tag',
    label: '태그',
    render: (row) => {
      const tag = pick(row, ['tag']);
      return tag ? (
        <Chip
          size="small"
          label={tag}
          sx={{
            height: 20,
            fontSize: 11,
            fontWeight: 700,
            bgcolor: colors.brand.primarySoft,
            color: colors.brand.primary,
          }}
        />
      ) : (
        <Typography variant="body2" sx={{ color: colors.text.muted }}>
          -
        </Typography>
      );
    },
  },
  {
    key: 'basePrice',
    label: '가격',
    align: 'right',
    render: (row) => (
      <Typography variant="body2" sx={{ fontVariantNumeric: 'tabular-nums' }}>
        {formatWon(pick(row, ['basePrice', 'price', 'amount', 'fee', 'cost']))}
      </Typography>
    ),
  },
  {
    key: 'status',
    label: '상태',
    render: (row) =>
      isActive(row) ? (
        <PaymentStatusBadge label="운영 중" status="success" />
      ) : (
        <PaymentStatusBadge label="중지" status="neutral" />
      ),
  },
  {
    key: 'code',
    label: '코드',
    render: (row) => (
      <Typography variant="caption" sx={{ color: colors.text.muted }}>
        {pick(row, ['courseId', 'code', 'id', '_id'], '-')}
      </Typography>
    ),
  },
];

const WashPrograms = () => (
  <ModernwashListScreen
    title="세차 프로그램"
    description="ModernWash 키오스크에 구성된 세차 코스예요. 원천을 그대로 읽어 보여주며, 여기서는 수정하지 않습니다."
    fetcher={fetchModernwashCourses}
    columns={COLUMNS}
    getRowKey={(row, index) => pick(row, ['courseId', 'id', '_id', 'code'], `course-${index}`)}
    emptyText="등록된 세차 프로그램이 없어요."
    minWidth={640}
  />
);

export default WashPrograms;
